import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  height: 100%;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  color: #3e3d3f;
  background: transparent;
  @media (max-width: 1366px) {
    width: 80px;
    font-size: 14px;
  }
`;
